import {
	clubReportSchema,
	clubReportSummarySchema,
	type ReportStatus,
	type UpdateReportStatus,
} from "../schemas/report";
import { fetchApi, paginatedSchema } from "./internal";

export const reports = {
	list: (status: ReportStatus | "all" = "open", limit = 50, offset = 0) =>
		fetchApi(
			`/admin/clubs/reports?status=${status}&limit=${limit}&offset=${offset}`,
			paginatedSchema(clubReportSchema),
		),
	summary: (status: ReportStatus | "all" = "open", limit = 50, offset = 0) =>
		fetchApi(
			`/admin/clubs/reports/summary?status=${status}&limit=${limit}&offset=${offset}`,
			paginatedSchema(clubReportSummarySchema),
		),
	listByClub: (clubId: string, status: ReportStatus | "all" = "all", limit = 50, offset = 0) =>
		fetchApi(
			`/admin/clubs/${clubId}/reports?status=${status}&limit=${limit}&offset=${offset}`,
			paginatedSchema(clubReportSchema),
		),
	updateStatus: (id: string, body: UpdateReportStatus) =>
		fetchApi(`/admin/clubs/reports/${id}`, clubReportSchema, {
			method: "PATCH",
			body: JSON.stringify(body),
		}),
};
